module.exports = __webpack_public_path__ + "static/media/opposing.b2440659.svg";